import React from "react";
import { Box, Typography } from "@mui/material";

// ETT linkage status → chip label + color. Shared by the students roster and the student
// ETT-info modal so the same status always reads identically wherever it's shown.
export const LINKAGE = {
    linked: { label: "Linked", color: "success" },
    email_unresolved: { label: "Email unresolved", color: "warning" },
    no_ett_email: { label: "No ETT email", color: "default" },
    no_active_plan: { label: "No active plan", color: "error" },
};

// A labelled group for the prep-program forms: a small overline caption above its
// fields. Shared by the editor tabs and the homework/exam dialogs so grouping looks
// consistent everywhere.
export const Field = ({ label, children }) => (
    <Box>
        {/* mb clears the outlined inputs' floating label, which sits on their top
            border — without it the group label and the field label collide. */}
        <Typography variant="overline" color="text.secondary" sx={{ display: "block", lineHeight: 1.4, mb: 1.25 }}>
            {label}
        </Typography>
        {children}
    </Box>
);

export default Field;
